import React from 'react';
import './App.css';

const Footer = () => {
  return (
    <footer class="page-footer page-footer-custom">
      <div className="footer">
        © 2026 - United Methodist Grammar School, Ilesa, Osun State, Nigeria. 95 Set Alumnis - email admin at <a href="mailto:cyu437@yahoo.com" className="footer-email">cyu437@yahoo.com</a>
      </div>
    </footer>
  );
};

export default Footer;
//&lt;a class="grey-text text-lighten-4 right" href="#!">&lt;/a>
